import React from "react";
import "./SideLinks.css";
import { Link } from "@mui/material";

const sideLinks = [
  {
    img: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-bt-loan-1738392266339.webp",
    text: "Personal Loan Balance Transfer with MinEMI: Save More on Your Loan",
    path: "/calculators/financial-insights-and-tools/personal-loan-balance-transfer-blog",
  },
  {
    img: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-1737028012223.webp",
    text: "Home Loan Balance Transfer with MinEMI: Save More on Your Mortgage",
    path: "/calculators/financial-insights-and-tools/home-loan-balance-transfer-blog",
  },
  {
    img: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-1737027764144.webp",
    text: "What Is a Balance Transfer, and Should You Do One in India?",
    path: "/calculators/financial-insights-and-tools/what-is-balance-transfer-blog",
  },
  {
    img: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-bt-loan-1738393420849.webp",
    text: " Car Loan Balance Transfer with MinEMI: Drive Your Savings Further",
    path: "/calculators/financial-insights-and-tools/car-loan-balance-transfer-blog",
  },
];

const SideLinks = () => {
  return (
    <>
      <div className="cc_bl_side_bar">
        <div className="side_heading">
          <p>ON A SIMILAR NOTE...</p>
        </div>
        {sideLinks.map((link, index) => (
          <div key={index} className="side_links_data d-flex pb-3 ">
            <div className="d-flex gap-3">
              <img
                src={link.img}
                alt={link.text}
                style={{ width: 76, height: 76 }}
              />
              <Link
                href={link.path}
                underline="hover"
                sx={{
                  fontSize: "13px",
                  lineHeight: "20px",
                  fontWeight: 400,
                  cursor: "pointer",
                  letterSpacing: "0.48px",
                }}
                className="archivo"
              >
                {link.text}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SideLinks;
